import { render, staticRenderFns } from "./Responsible-NoClose-issue.vue?vue&type=template&id=51302d59"
import script from "./Responsible-NoClose-issue.vue?vue&type=script&lang=js"
export * from "./Responsible-NoClose-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports